import { LtiEntity } from '../../Entities';

export const talisType = 'talis';

/** An LTI block is accepted to be in the progress of loading data,
 *  if  its data  field is  empty.  Currently,  Talis  LTI  blocks
 *  don't receive message after content selection so a random link
 *  id is explicitly set immediately after adding the block to the
 *  document.
 */
export type TalisEntity = LtiEntity & {
  data: { linkId: string };
};
